import { DownloadCSV } from '../../core/slots/DownloadCSV.js';
import { PIE_CHART_DISPLAY_NAME } from '../constants.js';

export const PieChartDownloadCSVSlot = DownloadCSV(PIE_CHART_DISPLAY_NAME);
